const wiggleRoom = 100;
export const calculateMaxHeight = (windowHeight: number, parentBottomPosition: number) => {
    const maxHeight = windowHeight - parentBottomPosition - wiggleRoom;
    if (maxHeight < wiggleRoom) {
        return undefined;
    }
    return maxHeight;
};
